import { useContext } from "react";
import { useHistory } from "react-router-dom";
import { TableContext } from "../../index";
import * as urlService from "../../view/urlService";

export const useParameterTableHelper = () => {

    const history = useHistory();
    const { config, setConfig } = useContext(TableContext);

    const hardReload = (props = {}) => {
        setConfig({
            ...config,
            selected: [],
            selectAll: false,
            hardReload: true,
            lastUpdated: Date.now(),
            ...props
        });
        history.push({ pathname: '/parameters' });
    }

    const onNameClick = () => {
        history.push({
            pathname: history.location.pathname,
            search: urlService.updateSort('name')
        })
    }
    const onValueClick = () => {
        history.push({
            pathname: history.location.pathname,
            search: urlService.updateSort('value')
        })
    }


    const updatePagination = (page, size) => {
        history.push(
            {
                pathname: history.pathname,
                search: urlService.updatePagination(page, size)
            }
        )
    }

    return {
        hardReload,
        onNameClick,
        onValueClick,
        updatePagination
    }
}
